import React from "react";
import { Checkbox, InputNumber } from "antd";

const VoucherItem = ({
  addClass,
  name,
  isDisableChecked,
  onDisableChange,
  isChecked,
  onCheckChange,
  onInputChange,
  value,
}) => {
  return (
    <div className={`voucher-select-group ${addClass ? addClass : ""}`}>
      <input
        type="radio"
        name="voucher"
        id={name}
        onChange={onCheckChange}
        defaultChecked={isChecked || false}
      />
      <label htmlFor={name} className="voucher-checkmark">
        <div className="voucher-select-head">
          <h4>{name} Voucher</h4>
          <div className="input-group !mb-0">
            <label htmlFor={`disable_${name}`} className="checkbox">
              <Checkbox onChange={onDisableChange} checked={isDisableChecked} id={`disable_${name}`} />
              Disable Voucher
            </label>
          </div>
        </div>

        <div className="input-group mb-0">
          <label>Interest Rate</label>
          <InputNumber
            type="number"
            min={0}
            disabled={isDisableChecked}
            prefix="%"
            name={name}
            placeholder="0"
            precision={2}
            step="0.01"
            className="!w-[148px] cusAdmInputNumber2 percentage_right arrHid"
            value={value !== undefined ? value : ""}
            onChange={onInputChange}
          />
        </div>
      </label>
    </div>
  );
};

export default VoucherItem;
